import { z } from 'zod';
import { listResponse } from '../../utils/listResponse';
import { deleteRecommendationSchema } from '../models/deleteRecommendation.schema';
import { deleteRecommendationListQueryEncoderSchema } from './list.schema';

export type DeleteRecommendationListQueryEncoder = {
  queue?: number;
};

export const list = (query: DeleteRecommendationListQueryEncoder = {}) => {
  return {
    endpoint: `/delete_recommendations`,
    method: 'GET',
    responseSchema: listResponse(deleteRecommendationSchema),
    query: { ...query, includeTotal: true },
    querySchema: deleteRecommendationListQueryEncoderSchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
